import React, { useState } from "react";
import { Check, Maximize2 } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { Reveal, SectionHeading } from "./Reveal";
import { LOCATION_MAPS } from "../data/media";
import { ImageLightbox } from "./ImageLightbox";

export const Location = () => {
  const { t } = useLang();
  const [lightbox, setLightbox] = useState(null);

  return (
    <section id="location" className="relative py-24 md:py-32 bg-[#0A0A0A]" data-testid="location-section">
      <div className="px-6 md:px-12 lg:px-20">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div>
            <SectionHeading overline={t.location.overline} title={t.location.title} text={t.location.text} />
            <ul className="mt-10 space-y-4">
              {t.location.advantages.map((adv, i) => (
                <Reveal key={i} delay={0.05 * i}>
                  <li className="flex items-start gap-4" data-testid={`location-adv-${i}`}>
                    <span className="mt-0.5 h-6 w-6 shrink-0 border border-[#D4AF37]/40 flex items-center justify-center">
                      <Check size={13} strokeWidth={1.6} className="text-[#D4AF37]" />
                    </span>
                    <span className="text-sm sm:text-base text-[#FFFFF0]/75 font-light leading-relaxed">{adv}</span>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>

          <Reveal delay={0.12}>
            <div className="grid grid-cols-2 gap-4">
              {LOCATION_MAPS.map((src, i) => (
                <div
                  key={i}
                  onClick={() => setLightbox(i)}
                  className={`group relative overflow-hidden border border-[#2E2E2E] cursor-zoom-in ${
                    i === 0 ? "col-span-2 aspect-[16/9]" : "aspect-square"
                  }`}
                  data-testid={`location-map-${i}`}
                >
                  <img src={src} alt={`Lokasyon ${i + 1}`} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700" />
                  <div className="absolute inset-0 bg-black/30 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                    <Maximize2 size={20} strokeWidth={1.3} className="text-[#FFFFF0]/0 group-hover:text-[#FFFFF0] transition-colors" />
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>

      {lightbox !== null && (
        <ImageLightbox
          items={LOCATION_MAPS}
          index={lightbox}
          onClose={() => setLightbox(null)}
          onPrev={() => setLightbox((p) => (p - 1 + LOCATION_MAPS.length) % LOCATION_MAPS.length)}
          onNext={() => setLightbox((p) => (p + 1) % LOCATION_MAPS.length)}
          downloadLabel={t.plans.download}
        />
      )}
    </section>
  );
};
